import en from './en.json';
import ru from './ru.json';

export const translations = {
    en,
    ru,
} as const;

export type Language = keyof typeof translations;
export type Translations = typeof en;

export const languages: { code: Language; name: string; nativeName: string; }[] = [
    { code: 'en', name: 'English', nativeName: 'EN' },
    { code: 'ru', name: 'Russian', nativeName: 'RU' },
];

export const isRTL = (_lang: Language): boolean => false;

export { en, ru };

